import { render, staticRenderFns } from "./SocialPicto.vue?vue&type=template&id=d6f3b674&scoped=true&v-once=true&"
import script from "./SocialPicto.vue?vue&type=script&lang=js&"
export * from "./SocialPicto.vue?vue&type=script&lang=js&"
import style0 from "./SocialPicto.vue?vue&type=style&index=0&id=d6f3b674&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f3b674",
  null
  
)

export default component.exports